import { FunctionComponent } from 'react';

import ExampleBanner from '../ExampleBanner';

export interface BannerWrapperProps {
  children: JSX.Element;
}

const BannerWrapper: FunctionComponent<BannerWrapperProps> = function ({
  children,
}) {
  return (
    <>
      <ExampleBanner />
      {children}
    </>
  );
};

export default BannerWrapper;
